export default theme => ({
  wrapper: {
    backgroundColor: theme.backgroundColor,
    minHeight: theme.minHeight,
    paddingBottom: 15
  },
  grid: {
    backgroundColor: 'white',
    margin: '15px auto 0',
    paddingTop: 15
  },
  regionsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  liensCategories: {
    display: 'inline-block',
    margin: 5
  },
  categorySelected: {
    display: 'inline-block',
    margin: 5,
    backgroundColor: theme.Plan.colorButtonSelected.backgroundColor,
    borderColor: theme.Plan.colorButtonSelected.borderColor,
    color: theme.Plan.colorButtonSelected.textColor,
    cursor: 'pointer'
  },
  hrSeparator: {
    borderColor: theme.Plan.hrColor,
    marginTop: 5
  },
  ads: {
    textAlign: 'center',
    marginTop: 15
  },
  bottomContainer: {
    textAlign: 'center',
    marginTop: 15,
    marginBottom: 15
  }
})
